module.exports = __webpack_public_path__ + "static/img/office-img-2-300x189.aaf099b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office-img-2-300x189.jpg
// module id = IqOE
// module chunks = 0